import { createContext, ReactNode, useContext } from "react";
import { ViewNames } from "../types";

type ViewContextType = {
  view: ViewNames;
};

const ViewContext = createContext<ViewContextType | undefined>(undefined);

export const ViewProvider = ({
  view,
  children,
}: {
  view: ViewNames;
  children: ReactNode;
}) => {
  return (
    <ViewContext.Provider value={{ view }}>{children}</ViewContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useView = () => {
  const context = useContext(ViewContext);
  if (!context) {
    throw new Error("useView must be used within a ViewProvider");
  }
  return context.view;
};
